import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    FRIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={FRIconImg} preview={false}/>
